module.exports = __webpack_public_path__ + "static/img/page_bgi_2.daab06a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/page_bgi_2.jpg
// module id = 2DDZ
// module chunks = 34